import type { CSSProperties, HTMLAttributes, ReactNode } from "react";

interface ScenarioFlowBoardProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}
function ScenarioFlowBoard({
  children,
  style,
  ...restProps
}: ScenarioFlowBoardProps) {
  const boardStyle: CSSProperties = {
    display: "flex",
    gap: 24,
    alignItems: "flex-start",
    overflow: "visible",
    padding: 24,
    minHeight: 120,
    width: "100%",
    boxSizing: "border-box",
    ...style,
  };

  return (
    <div {...restProps} style={boardStyle}>
      {children}
    </div>
  );
}

export default ScenarioFlowBoard;
